import React from 'react';
// Components
import SetupStream from 'components/common/SetupStream/SetupStream';

const SetupAthleteStream = (): JSX.Element => {
  return <SetupStream />;
};

export default SetupAthleteStream;
